/** Runs `run` over `items` with at most `limit` at once. */
export const runWithConcurrency = async <T>(
  items: T[],
  limit: number,
  run: (item: T) => Promise<void>
): Promise<void> => {
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const item = items[next];
      next += 1;
      await run(item);
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, worker)
  );
};
